import { OrganizationDocumentsPage } from "@/pages/organisaties/$organizationId/documenten"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/organisaties/$organizationId/documenten/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "organizations"),
})

function RouteComponent() {
  const { organizationId } = useParams({
    from: "/beheer/organisaties/$organizationId",
  })

  return <OrganizationDocumentsPage organizationId={Number(organizationId)} />
}
